import { render, staticRenderFns } from "./ProductExternalSwitch.vue?vue&type=template&id=02b7d0c1&"
import script from "./ProductExternalSwitch.vue?vue&type=script&lang=js&"
export * from "./ProductExternalSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports